import page from './Error.vue';
export default page;


// WEBPACK FOOTER //
// ./src/components/page/error/index.js